import * as os from "os";

export function getUserInfo() {
  return os.userInfo();
}

export function getUserPlatform() {
  return os.platform();
}
